import styled from 'styled-components';

export const SpeakersTableContainer = styled.div`
  width: 100%;
`;

export const SelectSpeakerButton = styled.button`
  display: flex;
  gap: 1rem;
  padding: 0.1rem 1rem;
  font-size: 0.9rem;
  background-color: ${({ theme }: {theme: any}) => theme.themePrimary};
  color: #ffffff;
  border-radius: 1rem;
  border: none;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  height: 100%;

  &:hover {
    background-color: ${({ theme }: {theme: any}) => theme.themePrimary};
    transition: all 0.3s ease;
  }
`;

export const PlayButton = styled.button`
  border: none;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }: {theme: any}) => theme.themePrimary};
  cursor: pointer;
  justify-content: center;
  align-items: center;
  height: 100%;

  &:hover {
    filter: brightness(1.2);
    transition: all 0.3s ease;
  }
`;
